<template>
  <button class="mapboxgl-ctrl-geolocate"
    type="button"
    title="Home"
    aria-label="Home"
    onclick="window.location.href='/'">
        <span class="fa fa-home" aria-hidden="true">
        </span>
  </button>
</template>

<script>
export default {

}
</script>

<style>

</style>